export default __webpack_public_path__ + "static/media/Component 72 – 1.229c02a6.svg";